import _regeneratorRuntime from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/createClass";
import * as qrcode from 'qrcode';
import styleText from './styles';

var Storage =
/*#__PURE__*/
function () {
  function Storage(keyPrefix) {
    _classCallCheck(this, Storage);

    this.keyPrefix = keyPrefix;
  }

  _createClass(Storage, [{
    key: "write",
    value: function () {
      var _write = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(key, data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage.setItem(this.storageKey(key), data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function write(_x, _x2) {
        return _write.apply(this, arguments);
      }

      return write;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", localStorage.getItem(this.storageKey(key)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read(_x3) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(key) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                localStorage.removeItem(this.storageKey(key));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function remove(_x4) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }, {
    key: "storageKey",
    value: function storageKey(key) {
      return "".concat(this.keyPrefix, "-").concat(key);
    }
  }]);

  return Storage;
}();

var BrowserTransport =
/*#__PURE__*/
function () {
  function BrowserTransport() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BrowserTransport);

    this.options = options;
    this.classPrefix = options.classPrefix || 'anchor-link';
    this.injectStyles = !(options.injectStyles === false);
    this.requestStatus = !(options.requestStatus === false);
    this.storage = new Storage(options.storagePrefix || 'anchor-link');
  }

  _createClass(BrowserTransport, [{
    key: "setupElements",
    value: function setupElements() {
      var _this = this;

      if (this.injectStyles && !this.styleEl) {
        this.styleEl = document.createElement('style');
        this.styleEl.type = 'text/css';
        var css = styleText.replace(/%prefix%/g, this.classPrefix);
        this.styleEl.appendChild(document.createTextNode(css));
        document.head.appendChild(this.styleEl);
      }

      if (!this.containerEl) {
        this.containerEl = this.createEl();
        this.containerEl.className = this.classPrefix;

        this.containerEl.onclick = function (event) {
          if (event.target === _this.containerEl) {
            event.stopPropagation();

            _this.hide();

            if (_this.activeCancel) {
              _this.activeRequest = undefined;

              _this.activeCancel('Modal closed');

              _this.activeCancel = undefined;
            }
          }
        };

        document.body.appendChild(this.containerEl);
      }

      if (!this.requestEl) {
        var wrapper = this.createEl({
          class: 'inner'
        });
        this.requestEl = this.createEl({
          class: 'request'
        });
        wrapper.appendChild(this.requestEl);
        this.containerEl.appendChild(wrapper);
      }
    }
  }, {
    key: "createEl",
    value: function createEl(attrs) {
      if (!attrs) attrs = {};
      var el = document.createElement(attrs.tag || 'div');

      if (attrs) {
        for (var _i = 0, _Object$keys = Object.keys(attrs); _i < _Object$keys.length; _i++) {
          var attr = _Object$keys[_i];
          var value = attrs[attr];

          switch (attr) {
            case 'tag':
              break;

            case 'text':
              el.appendChild(document.createTextNode(value));
              break;

            case 'class':
              el.className = "".concat(this.classPrefix, "-").concat(value);
              break;

            default:
              el.setAttribute(attr, value);
          }
        }
      }

      return el;
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.containerEl) {
        this.containerEl.classList.remove("".concat(this.classPrefix, "-active"));
      }

      this.clearTimers();
    }
  }, {
    key: "show",
    value: function show() {
      if (this.containerEl) {
        this.containerEl.classList.add("".concat(this.classPrefix, "-active"));
      }
    }
  }, {
    key: "displayRequest",
    value: function () {
      var _displayRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(request) {
        var sameDeviceRequest, sameDeviceUri, crossDeviceUri, isIdentity, title, subtitle, qrEl, linkEl, linkA, infoEl, infoTitle, infoSubtitle, actionEl, logoEl;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setupElements();
                sameDeviceRequest = request.clone();
                sameDeviceRequest.setInfoKey('same_device', true);
                sameDeviceRequest.setInfoKey('return_path', returnUrl());
                sameDeviceUri = sameDeviceRequest.encode(true, false);
                crossDeviceUri = request.encode(true, false);
                isIdentity = request.isIdentity();
                title = isIdentity ? 'Login' : 'Sign';
                subtitle = 'Scan the QR-code with your Anchor app.';
                qrEl = this.createEl({
                  class: 'qr'
                });
                _context4.next = 12;
                return qrcode.toString(crossDeviceUri, {
                  margin: 0,
                  errorCorrectionLevel: 'L'
                });

              case 12:
                qrEl.innerHTML = _context4.sent;
                linkEl = this.createEl({
                  class: 'uri'
                });
                linkA = this.createEl({
                  tag: 'a',
                  href: crossDeviceUri,
                  text: 'Open Anchor app'
                });
                linkA.addEventListener('click', function (event) {
                  event.preventDefault();
                  window.location.href = sameDeviceUri;
                });
                linkEl.appendChild(linkA);
                infoEl = this.createEl({
                  class: 'info'
                });
                infoTitle = this.createEl({
                  class: 'title',
                  tag: 'span',
                  text: title
                });
                infoSubtitle = this.createEl({
                  class: 'subtitle',
                  tag: 'span',
                  text: subtitle
                });
                infoEl.appendChild(infoTitle);
                infoEl.appendChild(infoSubtitle);
                actionEl = this.createEl({
                  class: 'actions'
                });
                actionEl.appendChild(qrEl);
                actionEl.appendChild(linkEl);
                emptyElement(this.requestEl);
                logoEl = this.createEl({
                  class: 'logo'
                });
                this.requestEl.appendChild(logoEl);
                this.requestEl.appendChild(infoEl);
                this.requestEl.appendChild(actionEl);
                this.show();

              case 31:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function displayRequest(_x5) {
        return _displayRequest.apply(this, arguments);
      }

      return displayRequest;
    }()
  }, {
    key: "onRequest",
    value: function onRequest(request, cancel) {
      this.activeRequest = request;
      this.activeCancel = cancel;
      this.displayRequest(request).catch(cancel);
    }
  }, {
    key: "onSessionRequest",
    value: function onSessionRequest(session, request, cancel) {
      if (session.metadata.sameDevice) {
        request.setInfoKey('return_path', returnUrl());
      }

      if (session.type === 'fallback') {
        this.onRequest(request, cancel);

        if (session.metadata.sameDevice) {
          // trigger directly on a fallback same-device session
          window.location.href = request.encode();
        }

        return;
      }

      this.activeRequest = request;
      this.activeCancel = cancel;
      this.setupElements();
      var timeout = session.metadata.timeout || 60 * 1000 * 2;
      var deviceName = session.metadata.name;
      var start = Date.now();
      var infoTitle = this.createEl({
        class: 'title',
        tag: 'span',
        text: 'Sign'
      });

      var updateCountdown = function updateCountdown() {
        var timeLeft = timeout + start - Date.now();
        var timeFormatted = timeLeft > 0 ? new Date(timeLeft).toISOString().substr(14, 5) : '00:00';
        infoTitle.textContent = "Sign - ".concat(timeFormatted);
      };

      this.countdownTimer = setInterval(updateCountdown, 500);
      updateCountdown();
      var infoEl = this.createEl({
        class: 'info'
      });
      infoEl.appendChild(infoTitle);
      var subtitle;

      if (deviceName && deviceName.length > 0) {
        subtitle = "Please open Anchor app on \u201C".concat(deviceName, "\u201D to review and sign the transaction.");
      } else {
        subtitle = 'Please review and sign the transaction in the linked wallet.';
      }

      var infoSubtitle = this.createEl({
        class: 'subtitle',
        tag: 'span',
        text: subtitle
      });
      infoEl.appendChild(infoSubtitle);
      emptyElement(this.requestEl);
      var logoEl = this.createEl({
        class: 'logo'
      });
      this.requestEl.appendChild(logoEl);
      this.requestEl.appendChild(infoEl);
      this.show();

      if (isAppleHandheld() && session.metadata.sameDevice) {
        window.location.href = 'anchor://link';
      }
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = undefined;
      }

      if (this.countdownTimer) {
        clearTimeout(this.countdownTimer);
        this.countdownTimer = undefined;
      }
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(request) {
      var _this2 = this;

      if (request === this.activeRequest) {
        this.clearTimers();

        if (this.requestStatus) {
          this.setupElements();
          var infoEl = this.createEl({
            class: 'info'
          });
          var logoEl = this.createEl({
            class: 'logo'
          });
          logoEl.classList.add('success');
          var infoTitle = this.createEl({
            class: 'title',
            tag: 'span',
            text: 'Success!'
          });
          var subtitle = request.isIdentity() ? 'Identity signed.' : 'Transaction signed.';
          var infoSubtitle = this.createEl({
            class: 'subtitle',
            tag: 'span',
            text: subtitle
          });
          infoEl.appendChild(infoTitle);
          infoEl.appendChild(infoSubtitle);
          emptyElement(this.requestEl);
          this.requestEl.appendChild(logoEl);
          this.requestEl.appendChild(infoEl);
          this.show();
          this.closeTimer = setTimeout(function () {
            _this2.hide();
          }, 1.5 * 1000);
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: "onFailure",
    value: function onFailure(request, error) {
      var _this3 = this;

      if (request === this.activeRequest) {
        this.clearTimers();

        if (this.requestStatus) {
          this.setupElements();
          var infoEl = this.createEl({
            class: 'info'
          });
          var logoEl = this.createEl({
            class: 'logo'
          });
          logoEl.classList.add('error');
          var infoTitle = this.createEl({
            class: 'title',
            tag: 'span',
            text: 'Transaction error'
          });
          var infoSubtitle = this.createEl({
            class: 'subtitle',
            tag: 'span',
            text: error.message || String(error)
          });
          infoEl.appendChild(infoTitle);
          infoEl.appendChild(infoSubtitle);
          emptyElement(this.requestEl);
          this.requestEl.appendChild(logoEl);
          this.requestEl.appendChild(infoEl);
          this.show();
          this.closeTimer = setTimeout(function () {
            _this3.hide();
          }, 5 * 1000);
        } else {
          this.hide();
        }
      }
    }
  }]);

  return BrowserTransport;
}();

export { BrowserTransport as default };

function emptyElement(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

var returnUrlAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var returnUrlAlphabetLen = returnUrlAlphabet.length;
/** Generate a return url with a random #fragment so mobile safari will redirect back w/o reload. */

function returnUrl() {
  var rv = window.location.href.split('#')[0] + '#';

  for (var i = 0; i < 8; i++) {
    rv += returnUrlAlphabet.charAt(Math.floor(Math.random() * returnUrlAlphabetLen));
  }

  return rv;
}

function isAppleHandheld() {
  return /iP(ad|od|hone)/i.test(navigator.userAgent);
}